





































































import { FaqApi, FormsApi } from "@/api";
import stateMixin from "@/mixins/state";

export default {
  data() {
    return {
      data: [],
      valid: true,
      fields: {
        question: ""
      },
      rules: {
        question: [v => !!v || "Dit veld is verplicht"]
      }
    };
  },
  mixins: [stateMixin],
  async mounted() {
    this.state = this.states.LOADING;
    const api = new FaqApi();
    try {
      const { data, status } = await api.faqGetFaqItems();

      this.state = this.states.LOADED;
      this.data = data;

      let self = this;

      this.data.forEach(item => {
        self.$set(item, "show", false);
      });
    } catch {
      this.state = this.states.ERROR;
    }
  },
  methods: {
    toggleItem: function(item) {
      item.show = !item.show;
    },
    submit: async function() {
      if (this.valid) {
        this.setState(this.states.LOADING);
        const api = new FormsApi();
        try {
          const result = await api.formsAskNonFaqQuestion({
            question: this.fields.question
          });
          this.setState(this.states.COMPLETED);

          (this.$refs.form as HTMLFormElement).reset();
        } catch {
          this.setState(this.states.ERROR);
        }
      }
    }
  }
};
